import React, {memo} from 'react';
import { Group, Stage, FastLayer, Rect, Line} from 'react-konva';

export default memo(({waveformPoints, rmsPoints, color}) => {
    return (
        <FastLayer>
          <Line bezier={true}  points={rmsPoints} stroke={color} strokeWidth={2}/>
        </FastLayer>
    );
});
